import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  const openModal = (type: 'privacy' | 'terms', e: React.MouseEvent) => {
    e.preventDefault();
    setModalContent(type);
  };
  const closeModal = () => setModalContent(null);
  return <footer className="bg-black pt-20 pb-8 border-t border-white/10 relative z-10" data-id="element-209">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-211">
          {/* Logo Column */}
          <div data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/bD3v9AavBa4gaqpbXra7Xw/Logo_Jet_Foce.png" alt="JetForce Aerospace" className="h-12 object-contain mb-4" data-id="element-213" />
            <p className="text-gold font-heading tracking-widest uppercase text-sm mb-6" data-id="element-214">
              Your Cargo. Our Mission.
            </p>
            <div className="w-12 h-0.5 bg-gold/50 mb-6" data-id="element-215"></div>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-216">
              Specialized aviation transportation and maintenance services
              keeping you airworthy, reliable, and ready to fly.
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-217">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-218">
              Services
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-219">
              <li data-id="element-220">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-221">
                  Aviation Cargo Transport
                </a>
              </li>
              <li data-id="element-222">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-223">
                  A&P Line Maintenance
                </a>
              </li>
              <li data-id="element-224">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-225">
                  100 Hour Inspections
                </a>
              </li>
              <li data-id="element-226">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-227">
                  Aircraft Interior Cleaning
                </a>
              </li>
              <li data-id="element-228">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-229">
                  Exterior Dry Wash
                </a>
              </li>
              <li data-id="element-230">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-231">
                  AOG Emergency Support
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div data-id="element-232">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-233">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-slate-400" data-id="element-234">
              <li data-id="element-235">
                <a href="tel:+17862620064" className="hover:text-gold transition-colors" data-id="element-236">
                  +1 786-262-0064
                </a>
              </li>
              <li data-id="element-237">
                <a href="mailto:dispatch@jetforceaviation.com" className="hover:text-gold transition-colors break-all" data-id="element-238">
                  dispatch@jetforceaviation.com
                </a>
              </li>
              <li data-id="element-239">
                <a href="mailto:operations@jetforceaviation.com" className="hover:text-gold transition-colors break-all" data-id="element-240">
                  operations@jetforceaviation.com
                </a>
              </li>
              <li data-id="element-241">
                <a href="https://jetforceaviation.com" className="hover:text-gold transition-colors" data-id="element-242">
                  jetforceaviation.com
                </a>
              </li>
            </ul>
          </div>

          {/* Coverage Column */}
          <div data-id="element-243">
            <h4 className="text-white font-heading font-bold uppercase tracking-wider mb-6" data-id="element-244">
              Coverage
            </h4>
            <p className="text-sm text-slate-400 leading-relaxed mb-4" data-id="element-245">
              Serving MIA, FLL, MCO and all major US airports.
            </p>
            <p className="text-sm text-slate-400 leading-relaxed" data-id="element-246">
              International operations in Barranquilla, Cartagena, Medellin and
              El Salvador.
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-247">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-sm text-slate-500" data-id="element-248">
            <span data-id="element-249">© 2025 JetForce Aerospace. All rights reserved.</span>
            <div className="flex gap-4" data-id="element-250">
              <a href="#" onClick={e => openModal('privacy', e)} className="hover:text-white transition-colors" data-id="element-251">
                Privacy Policy
              </a>
              <a href="#" onClick={e => openModal('terms', e)} className="hover:text-white transition-colors" data-id="element-252">
                Terms of Service
              </a>
            </div>
          </div>
          <div className="text-sm" data-id="element-253">
            <span className="text-slate-500" data-id="element-254">Website by </span>
            <span className="text-gold font-medium" data-id="element-255">Eleven Studio</span>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AnimatePresence data-id="element-256">
        {modalContent && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-257">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={closeModal} data-id="element-258" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-2xl bg-navy-light border border-gold/30 rounded-2xl shadow-2xl overflow-hidden flex flex-col max-h-[80vh]" data-id="element-259">
              <div className="flex justify-between items-center p-6 border-b border-white/10 bg-navy" data-id="element-260">
                <h3 className="text-xl font-heading font-bold text-white uppercase" data-id="element-261">
                  {modalContent === 'privacy' ? 'Privacy Policy' : 'Terms of Service'}
                </h3>
                <button onClick={closeModal} className="text-slate-400 hover:text-white transition-colors" data-id="element-262">
                  <X className="w-6 h-6" data-id="element-263" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-slate-300 text-sm space-y-4 custom-scrollbar" data-id="element-264">
                {modalContent === 'privacy' ? <>
                    <p data-id="element-265">
                      <strong data-id="element-266">Last Updated: May 2025</strong>
                    </p>
                    <p data-id="element-267">
                      JetForce Aerospace ("we," "our," or "us") is committed to
                      protecting your privacy. This Privacy Policy explains how
                      we collect, use, disclose, and safeguard your information
                      when you visit our website or use our services.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-268">
                      Information We Collect
                    </h4>
                    <p data-id="element-269">
                      We may collect personal information that you voluntarily
                      provide to us when you express an interest in obtaining
                      information about us or our products and services, when
                      you participate in activities on the Website, or otherwise
                      when you contact us. The personal information that we
                      collect depends on the context of your interactions with
                      us and the Website, the choices you make, and the products
                      and features you use.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-270">
                      How We Use Your Information
                    </h4>
                    <p data-id="element-271">
                      We use personal information collected via our Website for
                      a variety of business purposes described below. We process
                      your personal information for these purposes in reliance
                      on our legitimate business interests, in order to enter
                      into or perform a contract with you, with your consent,
                      and/or for compliance with our legal obligations.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-272">Contact Us</h4>
                    <p data-id="element-273">
                      If you have questions or comments about this notice, you
                      may email us at dispatch@jetforceaviation.com.
                    </p>
                  </> : <>
                    <p data-id="element-274">
                      <strong data-id="element-275">Last Updated: May 2025</strong>
                    </p>
                    <p data-id="element-276">
                      These Terms of Service constitute a legally binding
                      agreement made between you, whether personally or on
                      behalf of an entity ("you") and JetForce Aerospace ("we,"
                      "us" or "our"), concerning your access to and use of the
                      website as well as any other media form, media channel,
                      mobile website or mobile application related, linked, or
                      otherwise connected thereto.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-277">Services</h4>
                    <p data-id="element-278">
                      JetForce Aerospace provides specialized aviation
                      transportation, maintenance, and cleaning services. All
                      services are subject to availability and specific
                      contractual agreements entered into separately from this
                      website.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-279">Liability</h4>
                    <p data-id="element-280">
                      In no event will we or our directors, employees, or agents
                      be liable to you or any third party for any direct,
                      indirect, consequential, exemplary, incidental, special,
                      or punitive damages, including lost profit, lost revenue,
                      loss of data, or other damages arising from your use of
                      the site.
                    </p>
                    <h4 className="text-white font-bold mt-4" data-id="element-281">Governing Law</h4>
                    <p data-id="element-282">
                      These Terms shall be governed by and defined following the
                      laws of the State of Florida. JetForce Aerospace and
                      yourself irrevocably consent that the courts of Florida
                      shall have exclusive jurisdiction to resolve any dispute
                      which may arise in connection with these terms.
                    </p>
                  </>}
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </footer>;
}